function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m6.3045 11.904c0-2.2907 1.8401-4.1308 4.1308-4.1308h19.114c2.2907 0 4.0933 1.8401 4.0933 4.1308v16.411c0 2.2907-1.8025 4.0933-4.0933 4.0933h-19.114c-2.2907 0-4.1308-1.8025-4.1308-4.0933z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#adb9ca",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m15.427 20.123c0-0.28026 0.17708-0.51381 0.38957-0.51381h13.281c0.21249 0 0.35415 0.23355 0.35415 0.51381v2.0085c0 0.28026-0.14166 0.4671-0.35415 0.4671h-13.281c-0.21249 0-0.38957-0.18684-0.38957-0.4671z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m9.584 21.027c0-0.7135 0.6384-1.3519 1.3519-1.3519 0.75106 0 1.3519 0.6384 1.3519 1.3519 0 0.75106-0.60084 1.3519-1.3519 1.3519-0.7135 0-1.3519-0.60085-1.3519-1.3519z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m15.427 26.167c0-0.23681 0.21348-0.47362 0.42696-0.47362h13.271c0.21348 0 0.39138 0.23681 0.39138 0.47362v1.7761c0 0.23681-0.1779 0.43415-0.39138 0.43415h-13.271c-0.21348 0-0.42696-0.19734-0.42696-0.43415z"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m9.6491 27.11c0-0.7135 0.6384-1.3519 1.3519-1.3519 0.75106 0 1.3519 0.6384 1.3519 1.3519 0 0.75106-0.60084 1.3519-1.3519 1.3519-0.7135 0-1.3519-0.60084-1.3519-1.3519z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m10.398 7.7731h19.152c2.2907 0 4.0933 1.8776 4.0933 4.1308v4.7317h-27.338v-4.7317c0-2.2532 1.8401-4.1308 4.0933-4.1308z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m10.496 11.146c0-0.3762 0.24671-0.66879 0.56391-0.66879h17.799c0.3172 0 0.52867 0.2926 0.52867 0.66879v2.5498c0 0.3762-0.21147 0.62699-0.52867 0.62699h-17.799c-0.3172 0-0.56391-0.2508-0.56391-0.62699z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  strokeMiterlimit: 9
}), React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m6.4975 11.902c0-2.2912 1.8229-4.1316 4.0922-4.1316h18.935c2.2693 0 4.0549 1.8404 4.0549 4.1316v16.414c0 2.2911-1.7857 4.094-4.0549 4.094h-18.935c-2.2693 0-4.0922-1.8029-4.0922-4.094z",
  strokeMiterlimit: 9,
  strokeWidth: 0.9954
}), React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "m15.663 19.965c0-0.27891 0.1736-0.51133 0.38193-0.51133h13.02c0.20833 0 0.34721 0.23242 0.34721 0.51133v1.9988c0 0.2789-0.13888 0.46484-0.34721 0.46484h-13.02c-0.20833 0-0.38193-0.18594-0.38193-0.46484z",
  strokeWidth: 1.0382
}), React.createElement("path", {
  d: "m9.5452 21.059c0-0.75114 0.67206-1.4232 1.4232-1.4232 0.79067 0 1.4232 0.67207 1.4232 1.4232 0 0.79067-0.63254 1.4232-1.4232 1.4232-0.75114 0-1.4232-0.63254-1.4232-1.4232",
  strokeWidth: 1.0527
}), React.createElement("path", {
  d: "m15.577 26.084c0-0.25063 0.20993-0.50125 0.41986-0.50125h13.051c0.20993 0 0.38487 0.25062 0.38487 0.50125v1.8797c0 0.25062-0.17494 0.45948-0.38487 0.45948h-13.051c-0.20993 0-0.41986-0.20886-0.41986-0.45948z",
  strokeWidth: 1.0194
}), React.createElement("path", {
  d: "m9.6191 27.045c0-0.76368 0.68329-1.447 1.447-1.447 0.80387 0 1.447 0.68329 1.447 1.447 0 0.80387-0.6431 1.447-1.447 1.447-0.76368 0-1.447-0.6431-1.447-1.447",
  strokeWidth: 1.0703
}), React.createElement("path", {
  d: "m10.556 7.5806h18.965c2.2684 0 4.0534 1.9178 4.0534 4.2192v4.8329h-27.072v-4.8329c0-2.3014 1.8222-4.2192 4.0534-4.2192z",
  strokeWidth: 1.0057
}), React.createElement("path", {
  d: "m10.514 11.246c0-0.38532 0.24793-0.68501 0.5667-0.68501h17.886c0.31877 0 0.53128 0.29969 0.53128 0.68501v2.6116c0 0.38532-0.21251 0.6422-0.53128 0.6422h-17.886c-0.31877 0-0.5667-0.25688-0.5667-0.6422z",
  strokeWidth: 1.037
}))));
var SvgSurveyModelTabConstructs = function SvgSurveyModelTabConstructs(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabConstructs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Constructs.178367ec.svg";
export { ForwardRef as ReactComponent };